export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <p className="text-white text-2xl font-bold mb-3" style={{ fontFamily: 'serif' }}>RAMEN鶴</p>
            <p className="text-sm leading-relaxed">
              2026年1月、東京・足立区に誕生。<br />
              魂を込めた一杯をお届けします。
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">メニュー</h3>
            <div className="w-10 h-0.5 bg-red-800 mb-4"></div>
            <ul className="space-y-3 text-sm">
              <li>
                <button onClick={() => scrollToSection('menu')} className="hover:text-white transition-colors cursor-pointer">
                  お品書き
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors cursor-pointer">
                  こだわり
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('location')} className="hover:text-white transition-colors cursor-pointer">
                  アクセス
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">店舗案内</h3>
            <div className="w-10 h-0.5 bg-red-800 mb-4"></div>
            <ul className="space-y-3 text-sm">
              <li>平日：11:00〜15:00、17:00〜22:30</li>
              <li>週末・祝日：11:00〜22:30</li>
              <li>定休日：月曜</li>
              <li>東京都足立区東伊興1丁目13</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">フォローする</h3>
            <div className="w-10 h-0.5 bg-red-800 mb-4"></div>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-800 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-800 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-red-800 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs">© 2026 RAMEN鶴. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">
              利用規約
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
